
import WidgetDefaultNuxt from '../default/nuxt.vue';
import defaultValues from '@xd-rocket/attributes/src/attributes/xdvideo/default';

export default {
  name: 'WidgetVideoNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    const { getLocaleValue } = this;
    const {
      controls,
      loop,
      autoplay,
      poster,
      muted,
      hd,
      ld,
      fhd,
      type,
      pictureInPictureToggle,
      autoFullScreen,
      scrollAutoPlay,
      preload,
    } = this.values.xdvideo || defaultValues.xdvideo;
    let arr = [
      { key: 'ld', value: ld },
      { key: 'hd', value: hd },
      { key: 'fhd', value: fhd },
      { key: 'poster', value: poster },
    ];
    let _temp = {};
    arr.map((o) => {
      if (o.value) {
        let v = getLocaleValue(o.value);
        _temp[o.key] = v || '';
      } else {
        _temp[o.key] = '';
      }
    });
    return {
      needHack: false,
      pid: '',
      player: null,
      options: {
        controls,
        loop,
        poster: _temp.poster,
        muted: autoplay ? true : muted,
        autoplay: autoplay ? 'any' : false,
        scrollAutoPlay: autoplay && scrollAutoPlay,
        autoFullScreen,
        preload,
      },
      widgetClassName: 'widget-video',
      status: false,
      pictureInPictureToggle,
      sourceType: type,
      ..._temp,
      localePath: arr,
      wantStatus: {
        play: false,
        loop,
        fullScreen: false,
      },
    };
  },
  computed: {
    customClasses() {
      const { status } = this;
      return {
        ...this.classes,
        'rocket-video-playing': status,
        'rocket-video-without-pip': !this.pictureInPictureToggle,
      };
    },
    sources() {
      let result = [];
      const { localePath, sourceType } = this;
      localePath.map(({ key }) => {
        if (key !== 'poster' && this[key]) {
          result.push({
            label: key.toUpperCase(),
            src: this[key],
            type: sourceType,
          });
        }
      });
      return result;
    },

    optionsStr() {
      return JSON.stringify({ ...this.options, sources: this.sources });
    },
  },
  watch: {
    poster() {
      if (this.player) {
        this.player.poster(this.poster);
      }
    },
    sources(newVal) {
      if (this.player) {
        this.player.VideoControl().updateNormalSource(newVal);
      }
    },
  },
  mounted() {
    // 添加任意 canvas 或者视频宽度在 [21, 179] 之间时，qq x5 浏览器 在 vivo 手机上可以隐藏控件
    if (!window.__XDVIDEO__) {
      const { CONSTANT } = window.moo;
      if (CONSTANT.IS_ANDROID && CONSTANT.IS_BROWSER_QQ) this.needHack = true;
      (function (w, d, t, r) {
        w['__WEB_VIDEO_OBJECT__'] = r;
        w[r] =
          w[r] ||
          function () {
            (w[r].cmd = w[r].cmd || []).push(arguments);
          };
        var n = d.createElement(t),
          m = d.getElementsByTagName(t)[0];
        var j = d.createElement('link');
        j.rel = 'stylesheet';
        j.type = 'text/css';
        j.href = 'https://res.xdcdn.net/video/xdvideo-player.css';
        m.parentNode.insertBefore(j, m);
        n.async = 1;
        n.src = 'https://res.xdcdn.net/video/xdvideo-player.min.js';
        m.parentNode.insertBefore(n, m);
      })(window, document, 'script', '__XDVIDEO__');
    }
    window.__XDVIDEO__('register', {
      pick: this.$refs.xdvideo,
      afterCreate: this.handleAfterCreate,
      onError: (e) => {
        console.log(e);
      },
    });
  },
  methods: {
    initEvent() {
      this.rocketOn('rocket:video:play', true, () => {
        if (this.status) return;
        if (this.player) {
          this.play();
        } else {
          this.wantStatus.play = true;
        }
      });
      this.rocketOn('rocket:video:pause', true, () => {
        if (!this.status) return;
        if (this.player) {
          this.player.pause();
        } else {
          this.wantStatus.play = false;
        }
      });
      this.rocketOn('rocket:video:toggle', true, () => {
        if (this.player) {
          if (!this.status) {
            this.play();
          } else {
            this.player.pause();
          }
        } else {
          this.wantStatus.play = !this.wantStatus.play;
        }
      });
      this.rocketOn('rocket:video:requestFullscreen', true, () => {
        if (this.player) {
          if (!this.player.isFullscreen()) {
            this.player.requestFullscreen();
          }
        } else {
          this.wantStatus.fullScreen = true;
        }
      });
      this.rocketOn('rocket:video:exitFullscreen', true, () => {
        if (this.player) {
          if (this.player.isFullscreen()) {
            this.player.exitFullscreen();
          }
        } else {
          this.wantStatus.fullScreen = false;
        }
      });
      this.rocketOn('rocket:video:togglePipVisible', true, (value) => {
        this.pictureInPictureToggle = value;
      });
      this.rocketOn('rocket:video:toggleLoop', true, (value) => {
        if (this.player) {
          this.player.loop(value);
        } else {
          this.wantStatus.loop = value;
        }
      });
      this.rocketOn('rocket:video:toggleMuted', true, (value) => {
        if (this.player) {
          this.player.muted(!value);
        }
      });
      this.rocketOn('rocket:video:update-src', true, (type, v) => {
        let o = this.localePath.find((o) => o.key === type);
        if (!o) return;
        if (v instanceof Blob) {
          v = URL.createObjectURL(v);
        } else if (v.indexOf('http') !== 0) {
          return;
        }
        this[type] = v;
        o.value = v;
      });
    },
    play() {
      if (this.status) return;
      if (!this.player) return;
      this.player.autoplay('any');
    },
    handleAfterCreate(videojs) {
      let pid = videojs.getPid(this.$refs.xdvideo);
      if (pid === this.pid) return;
      this.pid = pid;
      this.player = videojs.getPlayer(pid);
      if (!this.player) return;
      this.rocketEmit('rocket:video:ready', true);
      this.player.on('playing', () => this.updateStatus());
      this.player.on('pause', () => this.updateStatus());
      this.player.on('ended', () => {
        this.rocketEmit('rocket:video:ended', true);
      });
      this.player.on('fullscreenchange', (e) => this.handleFullscreenChange(e));
      // 在初始化完成之前执行的动作，进行补救
      if (this.wantStatus.play && !this.options.autoplay) {
        this.play();
      }
      if (this.wantStatus.fullScreen) {
        this.player.requestFullscreen();
      }
      if (this.wantStatus.loop !== this.options.loop) {
        this.player.loop(this.wantStatus.loop);
      }
    },
    updateStatus() {
      let status = !this.player.paused();
      if (status !== this.status) {
        this.status = status;
        if (!status) {
          this.rocketEmit('rocket:video:paused', true);
        } else {
          this.rocketEmit('rocket:video:playing', true);
        }
      }
    },
    handleFullscreenChange() {
      this.rocketEmit(
        'rocket:video:fullscreenchange',
        true,
        this.player.isFullscreen()
      );
    },
  },
};
